export const findEventId = (obj: any, name: string) => {
  let event_id = null;
  obj?.length &&
    obj.map((x) => {
      if (x.name === name) event_id = x.id;
      return x;
    });
  return event_id;
};
